//react
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
//material UI
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  // Select,
  Box,
} from "@mui/material";

//react redux
import { useDispatch, useSelector } from "react-redux";

//slices
import {
  // addAnalysisAndGraphs,

  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

//functions
import {
  createAnalysis,
  getHeaders,
  getStringValues,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getPChart } from "../../../utils/computation/getPChart";
import Dropdown from "../../Dropdown";
import FunctionButtons from "../modules/FunctionButtons";
import { combineArrays } from "../../../utils/functions/combineArray";
import { checkArrayLengths } from "../../../utils/functions/checkArrayLength";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  //   width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
  maxHeight: "90%",
  overflow: "auto",
};

const VariableInput = ({ value, onChange, inputNumber }) => {
  const headerArray = ["Trials", "Defects", "Group Size"];
  return (
    <>
      <h3
        style={{
          marginTop: "10px",
        }}
      >
        {headerArray[inputNumber]}
      </h3>
      <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
        <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
        <Dropdown value={value} onChange={onChange} />
      </FormControl>
    </>
  );
};

const PChartModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  const [numberOfColumns, setNumberOfColumns] = useState(3);
  const [selectedColumns, setSelectedColumns] = useState(["", "", ""]);
  const [error, setError] = useState(false);

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //redux states
  const token = useSelector((state) => state.auth.token);
  const { data, columns } = useSelector((state) => state.dataTable);

  //functions
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleColumnSelectChange = (event, i) => {
    setSelectedColumns((oldArray) => {
      return oldArray.map((item, indexInOldArray) => {
        return indexInOldArray === i ? event.target.value : item;
      });
    });
  };

  const computeTTest = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const columnValuesArr = selectedColumns
      .filter((col) => col !== "") // remove empty values
      .map((col, index) => {
        if (index === 0) {
          return getStringValues(data, col);
        } else {
          return getColumnValues(data, col);
        }
      });

    const header = selectedColumns
      .filter((col) => col !== "") // remove empty values
      .map((col) => {
        let head = getHeaders(data, col);
        return head[0];
      });

    const arrayData = combineArrays(columnValuesArr, header);

    const res = checkArrayLengths(arrayData);

    const haveSameLength = res.isSuccess;
    haveSameLength ? setError(false) : setError(res.message);
    haveSameLength && closeMenu();

    if (columnValuesArr.length > 0 && haveSameLength) {
      let [result] = await Promise.all([
        getPChart({
          trials: columnValuesArr[0],
          defects: columnValuesArr[1],
          group_size: columnValuesArr[2],
        }),
      ]);

      const results = {
        ...result,
        column: selectedColumns.join(", "),
        title,
      };

      try {
        //update analysis subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          results
        );
        results.id = resFromCreateAnalysis.id;
      } catch (error) {
        console.log("error", error);
        return Swal.fire("Error", error.message, "error");
      }
    }

    dispatch(setIsLoading());
  };

  const inputs = [];
  for (let i = 0; i < numberOfColumns; i++) {
    inputs.push(
      <VariableInput
        key={i}
        value={selectedColumns[i]}
        onChange={(e) => handleColumnSelectChange(e, i)}
        inputNumber={i}
        options={columns}
      />
    );
  }

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid
          item
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{
            padding: "10px",
          }}
        >
          <Grid item xs={12} p={1}>
            <h3> Data Range</h3>

            {inputs}
          </Grid>
        </Grid>

        <FunctionButtons
          handleCloseModal={handleCloseModal}
          error={error}
          computeTTest={computeTTest}
        />
      </Box>
    </Modal>
  );
};

export default PChartModal;
